/**
 * ATHÉR product page - share row (blocks/ather-share.liquid).
 *
 * The device share button is shown only where navigator.share exists; copy
 * link writes the page address to the clipboard and says so in a polite live
 * region for two and a half seconds. Nothing is sent anywhere else.
 */
(function () {
  'use strict';

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    return new Promise(function (resolve, reject) {
      var area = document.createElement('textarea');
      area.value = text;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.opacity = '0';
      document.body.appendChild(area);
      area.select();
      var ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (e) {
        ok = false;
      }
      area.remove();
      if (ok) resolve();
      else reject(new Error('copy failed'));
    });
  }

  function setup(root) {
    if (root.hasAttribute('data-ather-share-ready')) return;
    root.setAttribute('data-ather-share-ready', '');
    var url = root.getAttribute('data-url') || window.location.href;
    var title = root.getAttribute('data-title') || document.title;
    var status = root.querySelector('[data-ather-share-status]');
    var timer = 0;

    function say(text) {
      if (!status) return;
      window.clearTimeout(timer);
      status.textContent = text;
      timer = window.setTimeout(function () {
        status.textContent = '';
      }, 2500);
    }

    var native = root.querySelector('[data-ather-share-native]');
    if (native && typeof navigator.share === 'function') {
      native.hidden = false;
      native.addEventListener('click', function () {
        navigator.share({ title: title, url: url }).catch(function () {});
      });
    }

    var copy = root.querySelector('[data-ather-share-copy]');
    if (copy) {
      copy.addEventListener('click', function () {
        copyText(url).then(
          function () {
            say(root.getAttribute('data-copied'));
          },
          function () {
            say(root.getAttribute('data-failed'));
          }
        );
      });
    }
  }

  /* Sticky add-to-cart: Horizon hides the bar when the footer comes into view,
     but a jump straight to the bottom shows it again after that check. While
     the footer is on screen the bar is hidden here (html[data-ather-footer]). */
  var footer = document.querySelector('footer');
  if (footer && typeof IntersectionObserver === 'function') {
    new IntersectionObserver(function (entries) {
      document.documentElement.toggleAttribute('data-ather-footer', entries[0].isIntersecting);
    }).observe(footer);
  }

  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-ather-share]'), setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // variant changes re-render the product section; the theme editor reloads it
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      init();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
